export interface DiaryUserLike {
  firstName?: string;
  lastName?: string;
  userName?: string;
  userID?: string;
  description?: string;
}

/** Formats user as: Last, First (USERID) */
export function formatDiaryUserDisplay(user: DiaryUserLike): string {
  const first = user.firstName?.trim() ?? '';
  const last = user.lastName?.trim() ?? '';
  const id = (user.userID ?? user.userName ?? '').toString().trim();
  const description = user.description?.trim();
  const label =
    last && first ? `${last}, ${first}` : description || user.userName?.trim() || '';

  if (!label) {
    return id || '—';
  }
  if (!id || label === id || label.includes(`(${id})`)) {
    return label;
  }
  return `${label} (${id})`;
}

/** Maps API user list items to select options with standard display format. */
export function mapDiaryUserOptions(users: DiaryUserLike[]): {
  description: string;
  value: string;
}[] {
  return users.map((item) => ({
    description: formatDiaryUserDisplay(item),
    value: String(item.userID ?? item.userName ?? ''),
  }));
}
